<template>
    <div class="i-rate-component" v-show="showStar">
        <div class="i-rate-module">
            <Icon class="i-rate-close" type="ios-close" @click="closeRate" />
            <span class="i-rate-title">评价</span>
            <section class="i-rate-content">
                <div class="rate-module">
                    <Rate v-model="valueHalf" @on-change="changeRate" icon="md-star"/>
                </div>
                <span class="rate-info" :class="{'rate-orange' : valueHalf}">{{rateInfo}}</span>
                <div class="hide-module" :class="{'show-module' : showInputBtn}">
                    <i-input class="rate-input" v-model="form.evaluate" type="textarea" :autosize="{minRows: 3,maxRows: 3}" :maxlength="60" placeholder="其他想说的"></i-input>
                    <div class="rate-btn" @click="submitRate">匿名提交</div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
  name: 'IRate',
  props: {
    showStar: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      valueHalf: 0,
      form: {
        evaluate: '',
      },
      rateInfo: '这堂课您觉得如何？',
      showInputBtn: false,
      rateInfoArr: ['需要很大改善', '需要改善', '一般', '比较满意', '非常满意'],
    }
  },
  methods: {
    submitRate () {
      this.$emit('submitRate', {
        rate: this.valueHalf,
        evaluate: this.form.evaluate,
      })
      this.$emit('closeRate')
    },
    closeRate () {
      this.$emit('closeRate')
      this.$emit('closeRate')
    },
    changeRate () {
      if (this.valueHalf) {
        this.showInputBtn = true
      }
      this.rateInfo = this.rateInfoArr[this.valueHalf - 1]
    },
  },
}
</script>

<style lang="scss">
.i-rate-component {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.6);
  .i-rate-module {
    background-color: #fff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: relative;
    min-width: 360px;
    .i-rate-close {
      position: absolute;
      left: 5px;
      top: 5px;
      font-size: 34px;
      cursor: pointer;
    }
    .i-rate-title {
      height: 44px;
      line-height: 44px;
      display: block;
      text-align: center;
      border-bottom: 1px solid #d8d8d8;
      font-size: 17px;
      color: #000;
    }
    .i-rate-content {
      padding: 20px 24px;
      min-height: 176px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .rate-module {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .ivu-rate-star-chart {
          font-size: 28px;
          color: #ed6c00;
        }
        .ivu-rate-star-zero {
          i {
            //color: #ed6c00;
          }
        }
        .ivu-rate-star-full {
          i {
            color: #ed6c00;
          }
        }
        .ivu-rate-star {
          margin: 0 5px;
        }
        .ivu-rate-star-full:before {
          color: #ed6c00;
          font-size: 28px;
        }
        .ivu-rate-star:before {
          font-size: 28px;
        }
      }
      .rate-info {
        display: block;
        text-align: center;
        font-size: 14px;
        color: #4a4a4a;
      }
      .rate-orange {
        color: #ed6c00;
      }
      .hide-module {
        transition: all 0.3s;
        height: 0;
        overflow: hidden;
        opacity: 0;
        margin-top: 32px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .rate-input {
          width: 240px;
          textarea {
            border-radius: 3px;
            background-color: rgba(248, 248, 248, 0.82);
            border: solid 0.5px rgba(0, 0, 0, 0.1);
            resize: none;
          }
          textarea:focus {
            box-shadow: none;
          }
        }
        .rate-btn {
          width: 240px;
          height: 32px;
          line-height: 32px;
          border-radius: 16px;
          background-color: #ed6c00;
          margin: 15px 0 20px 0;
          color: #fff;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .show-module {
        height: 140px;
        opacity: 1;
      }
    }
  }
}
</style>
